import React, { useMemo, useState } from 'react';
import CompanyReportSearch from '../components/CompanyReportSearch';
import CompanyReportsModal from '../components/CompanyReportsModal';
import './CompanyReports.css';


const CompanyReports = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const categories = useMemo(() => ([
    {
      title: '💻 IT Services',
      companies: [
        { symbol: 'TCS', name: 'Tata Consultancy Services' },
        { symbol: 'INFY', name: 'Infosys Limited' },
        { symbol: 'WIPRO', name: 'Wipro Limited' },
      ],
    },
    {
      title: '🏦 Banking & Finance',
      companies: [
        { symbol: 'HDFC', name: 'HDFC Bank' },
        { symbol: 'ICICIBANK', name: 'ICICI Bank' },
        { symbol: 'SBIN', name: 'State Bank of India' },
      ],
    },
    {
      title: '⛽ Energy & Oil',
      companies: [
        { symbol: 'RELIANCE', name: 'Reliance Industries' },
        { symbol: 'ONGC', name: 'Oil & Natural Gas Corp' },
        { symbol: 'IOC', name: 'Indian Oil Corporation' },
      ],
    },
    {
      title: '🚗 Automobile',
      companies: [
        { symbol: 'TATAMOTORS', name: 'Tata Motors' },
        { symbol: 'MARUTI', name: 'Maruti Suzuki' },
        { symbol: 'M&M', name: 'Mahindra & Mahindra' },
      ],
    },
  ]), []);

  const openCompany = (company) => {
    setSelectedCompany(company);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCompany(null);
  };

  return (
    <div className="company-reports-page">
      <div className="page-header">
        <div className="container">
          <h1>📊 Company Reports & Financial Documents</h1>
          <p>
            Access comprehensive financial reports, earnings calls, and corporate documents 
            from leading Indian companies. Search through detailed analysis and insights.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="features-section">
          <h2>🔍 What You Can Search</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3>Financial Performance</h3>
              <p>Revenue growth, profit margins, cash flow analysis, and key financial metrics</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📋</div>
              <h3>Quarterly Reports</h3>
              <p>Detailed quarterly earnings, business updates, and performance analysis</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Annual Reports</h3>
              <p>Comprehensive annual reports with strategic insights and future outlook</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🎤</div>
              <h3>Earnings Calls</h3>
              <p>Management insights from quarterly earnings calls and investor presentations</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🏢</div>
              <h3>Corporate Governance</h3>
              <p>Board updates, compliance reports, and corporate governance documents</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🌱</div>
              <h3>Sustainability</h3>
              <p>ESG reports, sustainability initiatives, and environmental impact analysis</p>
            </div>
          </div>
        </div>

        <div className="search-section">
          <CompanyReportSearch />
        </div>

        {/* <InfoSection /> */}

        <div className="companies-section">
          <h2>🏢 Featured Companies</h2>
          <p>Search through reports from leading Indian companies across various sectors</p>
          
          <div className="companies-grid">
            {categories.map((cat) => (
              <div className="company-category" key={cat.title}>
                <h3>{cat.title}</h3>
                <ul>
                  {cat.companies.map((c) => (
                    <li key={c.symbol}>
                      <button className="link-like" onClick={() => openCompany(c)}>
                        {c.symbol} - {c.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      <CompanyReportsModal isOpen={isModalOpen} onClose={closeModal} company={selectedCompany} />
    </div>
  );
};

export default CompanyReports;
